/**
 * Homey Admin V2 API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NycDataDto { 
    syncStatus: NycDataDto.SyncStatusEnum;
    nycId?: number;
}
export namespace NycDataDto {
    export const SyncStatusEnum = {
        synced: 'synced',
        not_synced: 'not-synced',
        sync_failed: 'sync-failed'
    } as const;
    export type SyncStatusEnum = typeof SyncStatusEnum[keyof typeof SyncStatusEnum];
}


